// extracted by mini-css-extract-plugin
module.exports = {"iconButton":"comments_iconButton__1GGh4","iconCommentBody":"comments_iconCommentBody__2i5ru","iconCommentRemove":"comments_iconCommentRemove__27y7X"};